import React, { useEffect, useRef, useContext } from 'react'
import NousConnaitre from '@pages/NousConnaitre'
import ShareImg from './link.svg'
import FB from './icon-social-fb.svg'
import In from './icon-social-in.svg'
import Tw from './icon-social-tw.svg'
import Gr from './icon-social-gr.svg'
import './navfeatures.scss'

const NavActions = () => {
	const ref = useRef()

	useEffect(() => {
		handleHide()
	}, [])
	const handleShow = () => {
		ref.current.className = 'is-flex'
	}
	const handleHide = () => {
		ref.current.className = 'is-hidden'
	}
	return (
		<div className="nav__features row">
			<NousConnaitre />
			<div
				className="cursor_pointer ml-2"
				onMouseEnter={handleShow}
				onMouseLeave={handleHide}
			>
				<img className="mt-xs-1" src={ShareImg} width="40px" />
				<div ref={ref}>
					<div className="nav_actions-links">
						<a href="https://www.facebook.com/elogiesiempidf/" target="_blank">
							<img src={FB} />
						</a>
						<a href="https://twitter.com/elogiesiemp" target="_blank">
							<img src={Tw} />
						</a>
						<a href="https://www.instagram.com/elogiesiemp/" target="_blank">
							<img src={Gr} />
						</a>
						<a
							href="https://www.linkedin.com/company/elogie-siemp/?originalSubdomain=fr"
							target="_blank"
						>
							<img src={In} />
						</a>
					</div>
				</div>
			</div>
		</div>
	)
}
export default NavActions
